import { cn } from '@/lib/utils';

import { profileLine } from '../profileSummary';
import type { LlmProfile } from '../types';

/**
 * A profile as everyone reads it (spec 214): its name, what it runs on, and the
 * admin's line saying what it is for.
 *
 * `option` sits inside a picker's item, so it adds no frame of its own; `card`
 * is the block under a step's profile field and in the read-only step panel.
 * The description wraps rather than truncates: it is at most one line of 200
 * characters, and cutting it would hide the very part a member reads it for.
 */
export function ProfileSummary({
  profile,
  variant,
}: {
  profile: Pick<
    LlmProfile,
    'name' | 'model' | 'effort' | 'max_turns' | 'description'
  >;
  variant: 'option' | 'card';
}) {
  return (
    <span
      data-slot="profile-summary"
      className={cn(
        'flex min-w-0 flex-col gap-0.5 text-left',
        variant === 'card' && 'border-border rounded-md border px-3 py-2',
      )}
    >
      <span className="text-sm">{profile.name}</span>
      <span className="text-muted-foreground text-xs">
        {profileLine(profile)}
      </span>
      {profile.description && (
        <span className="text-muted-foreground text-xs">
          {profile.description}
        </span>
      )}
    </span>
  );
}
